import { render, staticRenderFns } from "./recordView.vue?vue&type=template&id=13cc0e69&scoped=true&"
import script from "./recordView.vue?vue&type=script&lang=ts&"
export * from "./recordView.vue?vue&type=script&lang=ts&"
import style0 from "./recordView.vue?vue&type=style&index=0&id=13cc0e69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cc0e69",
  null
  
)

export default component.exports